<button
	*ngIf="itemCtrl"
	#selectButton
	[ngClass]="buttonStyle"
	mat-button
	class="select-button {{ buttonSize }} icon-only"
	[color]="buttonColor"
>
	<ng-container *ngIf="buttonText">{{ buttonText }}</ng-container><mat-icon *ngIf="iconName">{{ iconName }}</mat-icon>

	<mat-select
		#matSelect
		[multiple]="selectLayout === 'groups' || selectLayout === 'multiples'"
		[value]="currentValue"
		(closed)="removeOverlay()"
		[formControl]="itemCtrl"
		[compareWith]="compareWith"
	>
		<!-- Groups -->
		<ng-container *ngIf="selectLayout === 'groups'">
			<mat-optgroup *ngFor="let group of options; trackBy: trackByFn" [label]="group.name" class="condensed-options">
				<mat-option
					[value]="entityValue ? entity[entityValue] : entity"
					*ngFor="let entity of group.items; trackBy: trackByFn"
					[class.hidden]="entity.hideFromMenu"
					>{{ entity.name }}</mat-option
				>
			</mat-optgroup>
		</ng-container>

		<!-- Multiples -->
		<ng-container *ngIf="selectLayout === 'multiples'">
			<mat-option
				[value]="entityValue ? entity[entityValue] : entity"
				*ngFor="let entity of options; trackBy: trackByFn"
				[class.hidden]="entity.hideFromMenu"
			>
				{{ entity.name }}
			</mat-option>
		</ng-container>

		<!-- Singles -->
		<ng-container *ngIf="selectLayout === 'singles'">
			<mat-option
				*ngFor="let entity of options; trackBy: trackByFn"
				[value]="entityValue ? entity[entityValue] : (entity?.nam || entity)"
				[class.hidden]="entity.hideFromMenu"
			>
				{{ entity.name | titlecase }}
			</mat-option>
		</ng-container>

		<button
			*ngIf="applyButton"
			mat-flat-button
			class="icon-left sticky-bottom no-border-radius"
			color="primary"
			(click)="applyValue()"
		>
			<ng-container i18n="Apply Button Text@@assetManagerDialogApplyButtonLabel">Apply</ng-container><i class="icon icon-check"></i>
		</button>
	</mat-select>



</button>
